import styled, { keyframes } from 'styled-components';
import { Flex } from 'src/packages/core';
import React from 'react';

export const DesktopNoticeBarWrapper = styled((props) => <Flex {...props} />)`
  cursor: ${(props) => (!!props.onClick ? 'pointer' : 'initial')};

  * {
    cursor: ${(props) => (!!props.onClick ? 'pointer' : 'initial')};
  }
`;

export const MobileNoticeBarWrapper = styled((props) => <Flex {...props} />)`
  white-space: nowrap;
  display: none;

  &::-webkit-scrollbar {
    display: none !important;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }
`;

const ScorllingAnimation = keyframes`
 0% { opacity: 1; transform: translateX(0); }
 100% { opacity: 1;  transform: translateX(-100%); }
`;

export const MobileScrollingBar = styled.div<{ animationDuration?: number }>`
  display: flex;
  position: relative;
  width: max-content;
  white-space: nowrap;
  opacity: 0;
  transform: translateX(0);
  transition: all linear;
  will-change: transform, opacity;
  animation-name: ${ScorllingAnimation};
  animation-duration: ${(props) => props.animationDuration ?? 100}s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: normal;
`;
